import { OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { environment } from 'src/environments/environment';
var FlagApplicationDirective = /** @class */ (function () {
    function FlagApplicationDirective(templateRef, viewContainer) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this._appFlagApplicationMode = 'include';
    }
    Object.defineProperty(FlagApplicationDirective.prototype, "appFlagApplication", {
        get: function () {
            return this._appFlagApplication;
        },
        set: function (value) {
            this._appFlagApplication = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlagApplicationDirective.prototype, "appFlagApplicationMode", {
        get: function () {
            return this._appFlagApplicationMode;
        },
        set: function (value) {
            this._appFlagApplicationMode = value;
        },
        enumerable: true,
        configurable: true
    });
    FlagApplicationDirective.prototype.ngOnInit = function () {
        this.update();
    };
    FlagApplicationDirective.prototype.update = function () {
        // Determine if the current environment matches the flag
        var hasMatch = false;
        if (Array.isArray(this.appFlagApplication)) {
            hasMatch = this.appFlagApplication.some(function (application) { return application === environment.application; });
        }
        else if (typeof this.appFlagApplication === 'string') {
            hasMatch = this.appFlagApplication === environment.application;
        }
        // Hide or show depending on exclusion mode
        var include = (hasMatch && this.appFlagApplicationMode === 'include') ||
            !hasMatch && this.appFlagApplicationMode === 'exclude';
        if (include) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
        else {
            this.viewContainer.clear();
        }
    };
    return FlagApplicationDirective;
}());
export { FlagApplicationDirective };
